import { render, staticRenderFns } from "./TabsHorizontalModelA.vue?vue&type=template&id=b3079ea0"
import script from "./TabsHorizontalModelA.vue?vue&type=script&lang=js"
export * from "./TabsHorizontalModelA.vue?vue&type=script&lang=js"
import style0 from "./TabsHorizontalModelA.vue?vue&type=style&index=0&id=b3079ea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports